<template>
  <div class="ui segment">
    <div class="ui top attached label">
      <i class="info circle icon"></i>Variables:
    </div>
    <div>
      <b>name</b>
      : {{getI18n(observationsDetail[0].observation.observedProperty.name,"en")}}
    </div>
    <table class="ui celled table">
      <thead>
        <tr>
          <th></th>
          <th>Producer variable name</th>
          <th>Unit</th>
          <th>
            <i class="calendar check outline icon"></i> Temporal extent
          </th>
          <th>Description</th>
          <th>GCMD</th>
          <th>
            <i class="database icon"></i> Data access
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(obs, index) in observationsDetail" :key="index">
          <td :data-label="index">{{index + 1}}</td>
          <td data-label="Producer name">{{getI18n(obs.observation.observedProperty.name,"en")}}</td>
          <td data-label="Unit">{{getI18n(obs.observation.observedProperty.unit,"en")}}</td>
          <td data-label="Temporal extent">
            {{obs.observation.temporalExtent.dateBeg}}
            <br>
            {{obs.observation.temporalExtent.dateEnd}}
          </td>
          <td>
            <div
              data-label="Description"
              v-if="obs.observation.observedProperty.description != null"
            >{{getI18n(obs.observation.observedProperty.description,"en")}}</div>
          </td>
          <td data-label="GCMD">
            <div v-if="obs.observation.observedProperty.gcmdKeywords != null">
              <div v-if="obs.observation.observedProperty.gcmdKeywords != null">
                <div v-for="(gcmd, index) in observedProperty.gcmdKeywords" :key="index">
                  <span v-if="gcmd.category">{{gcmd.category}}</span>
                  <span v-if="gcmd.topic">> {{gcmd.topic}}</span>
                  <span v-if="gcmd.term">> {{gcmd.term}}</span>
                  <span v-if="gcmd.variableLevel1">> {{gcmd.variableLevel1}}</span>
                  <span v-if="gcmd.variableLevel2">> {{gcmd.variableLevel2}}</span>
                  <span v-if="gcmd.variableLevel3">> {{gcmd.variableLevel3}}</span>
                  <span v-if="gcmd.uuid">> {{gcmd.uuid}}</span>
                </div>
              </div>
            </div>
          </td>
          <td data-label="Data access">
            <div v-if="obs.observation.result.dataFile.name.length != 0">
              <div class="ui animated button" tabindex="0">
                <div class="visible content">Download</div>
                <div class="hidden content">
                  <i class="save icon"></i>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
</style>

<script>
export default {
  props: ["observationsDetail"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>
